<div class="rs-review-address" *ngIf="isFormInit">
  <div class="rs-review-address__title rs-review-step">{{'address.address' | translate}}</div>
  <div class="rs-review-address__subtitle rs-review-step">{{'address.business' | translate}}</div>
  <rs-address-form *ngIf="businessState" [state]="businessState" [inputForm]="businessAddressForm" [disabled]="true"></rs-address-form>
  <div class="rs-review-address__subtitle rs-review-step" *ngIf="different">{{'address.legal' | translate}}</div>
  <rs-address-form *ngIf="checkIsDifferentAndLegalState()" [state]="legalState" [inputForm]="legalAddressForm" [disabled]="true"></rs-address-form>
</div>
